import { gql, QueryResult, useQuery } from "@apollo/client";

import { Asset } from "../../../generated/gql/graphql";

const GET_ASSET = gql`
  query GetAsset($assetId: String!) {
    asset(id: $assetId) {
      id
      approval
      status
      sort
      type
      name
      image
      parentId
      categoryId
      nextAssetId
      prevAssetId
      contentAmount
      contentUnit
      favorite
      geometry
      metashotsType
      # ToDo: Pls fix endpoint expectation
      # languageRegionsId
      assetTypes
      brandId
      collectionId
      oderIndex
      dateCreated
      dateUpdated
      adaptionId
      projectId
      masterId
      productType {
        id
        name
      }
      labelType {
        id
        name
      }
      typeOfShot {
        id
        name
      }
    }
  }
`;

export default function useAsset(
  assetId: string
): QueryResult<{ asset: Asset }> {
  return useQuery(GET_ASSET, {
    variables: {
      assetId,
    },
    fetchPolicy: "network-only",
  });
}
